import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  updateDiagnosisById,
  UpdateDiagnosisByIdPayload,
} from '@/services/update-diagnosis-by-id'

export const useUpdateDiagnosisById = (diagnosisId: string) => {
  const mutation = useMutation({
    mutationFn: (payload: UpdateDiagnosisByIdPayload) => {
      return updateDiagnosisById(diagnosisId, payload)
    },
    onError: (error: Error) => {
      toast.error(`Erro ao atualizar o nome do diagnóstico: ${error.message}`)
    },
  })

  return mutation
}
